import { produce } from "../../../../immer/index.js";
function createRefreshFormStatus(store, getLogger, getSubscribersApi) {
  const { notifyMetaSubscribers, notifyFormSubscribers } = getSubscribersApi();
  return (silent) => {
    const log = getLogger();
    const meta = Object.values(store.fields).reduce(
      (acc, storeField) => {
        const { pristine, indeterminate, valid, invalid } = acc;
        const field = storeField;
        return {
          valid: valid && field.status === "valid",
          invalid: invalid || field.status === "invalid",
          pristine: pristine && field.status === "pristine",
          indeterminate: indeterminate || field.status === "indeterminate"
        };
      },
      {
        pristine: true,
        indeterminate: false,
        valid: true,
        invalid: false
      }
    );
    const nextStatus = meta.pristine ? "pristine" : meta.valid ? "valid" : meta.invalid ? "invalid" : "indeterminate";
    log("refreshFormStatus", nextStatus);
    if (nextStatus !== store.meta.status) {
      store.meta = produce(store.meta, (draft) => {
        draft.status = nextStatus;
      });
      if (!silent) {
        notifyMetaSubscribers();
        notifyFormSubscribers();
      }
      return true;
    }
    return false;
  };
}
export {
  createRefreshFormStatus
};
//# sourceMappingURL=createRefreshFormStatus.js.map
